import { useEffect, useState } from "react";
import Modal from "react-modal/lib/components/Modal";
import "./style.css";
import ListFilterCaixaColaborador from "../combo-caixa-colaborador";
import RadioButton from "../../radio-group";
import HeaderFilter from "../../header/filter";

Modal.setAppElement("#root");

function FilterModal(props) {
	const [nome, setNome] = useState("");

	const [selectedLabel, setSelectedLabel] = useState("Data da venda");
	const [selectedOption, setSelectedOption] = useState("dtVenda");

	const optionsRadioButton = [
		{ id: "dtvenda", label: "Data da venda", value: "dtVenda" },
		{
			id: "dtvencimento",
			label: "Data de vencimento",
			value: "dtVencimento",
		},
	];

	useEffect(() => {
		setNome("");
	}, []);

	function parametrosData(dataAtual, parametro) {
		parametro == "ini" ? props.setDtIni(dataAtual) : props.setDtFim(dataAtual);
	}

	function handleList() {
		props.filterData && props.tipoData(selectedOption, selectedLabel);
		if (props.setNomeOuColaborador) props.setNomeOuColaborador(nome);
		props.handleList();
	}

	const handleRadioChangeData = (value, label) => {
		setSelectedOption(value);
		setSelectedLabel(label);
	};

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.onRequestClose}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<button type="button" onClick={props.onRequestClose} className="react-modal-close">
				{/* <img src={} alt="Fechar" /> */}
			</button>

			<div className="container-fluid h-100 endereco">
				<HeaderFilter title={props.title} subTitle="Pesquisar por..." />
				{/* <div className="col-12 mt-4">
					<h6 className="text-xs border-botton mt-3 text-secondary">Pesquisar por..</h6>
				</div> */}
				<div className="mt-3">
					{props.filterData && (
						<RadioButton
							options={optionsRadioButton}
							onChange={handleRadioChangeData}
							defaultChecked={selectedOption}
						/>
					)}

					{/* {props.options.map((option, index) => (
						<div key={index}>
							<input type="radio" id={option.id} name="radio-group" value={option.value} checked={selectedOption === option.value} onChange={handleRadioChange} />
							<label htmlFor={option.id}>{option.label}</label>
						</div>
					))} */}
				</div>

				{props.filterName ? (
					<div className="form-floating mb-3">
						<input
							type="text"
							value={props.nome}
							onChange={(e) => {
								props.setNome(e.target.value);
							}}
							className="form-control"
							id="floatingInput"
							placeholder="name@exemplo.com"
						/>
						<label htmlFor="floatingInput">Nome do {props.tipoPesquisaNome}</label>
					</div>
				) : null}

				{props.monthYear ? (
					<div className="d-flex col-12 gap-2">
						<div className="form-floating mb-3 col-6">
							<select
								className="form-select"
								value={props.selectedMonth}
								onChange={(e) => props.setSelectedMonth(e.target.value)}
								id="floatingSelectMonth"
							>
								<option value="1">Janeiro</option>
								<option value="2">Fevereiro</option>
								<option value="3">Março</option>
								<option value="4">Abril</option>
								<option value="5">Maio</option>
								<option value="6">Junho</option>
								<option value="7">Julho</option>
								<option value="8">Agosto</option>
								<option value="9">Setembro</option>
								<option value="10">Outubro</option>
								<option value="11">Novembro</option>
								<option value="12">Dezembro</option>
							</select>
							<label htmlFor="floatingSelectMonth">Mês</label>
						</div>
						<div className="form-floating mb-3 col-6">
							<select
								className="form-select"
								value={props.selectedYear}
								onChange={(e) => props.setSelectedYear(e.target.value)}
								id="floatingSelectYear"
							>
								{Array.from({ length: 11 }, (_, i) => new Date().getFullYear() - 5 + i).map((ano) => (
									<option key={ano} value={ano}>
										{ano}
									</option>
								))}
							</select>
							<label htmlFor="floatingSelectYear">Ano</label>
						</div>
					</div>
				) : props.onlyYear ? (
					<div className="form-floating mb-3">
						<select
							className="form-select"
							value={props.anoSelecionado}
							onChange={(e) => props.setAnoSelecionado(e.target.value)}
							id="floatingSelectAno"
						>
							{Array.from({ length: 11 }, (_, i) => new Date().getFullYear() - 5 + i).map((ano) => (
								<option key={ano} value={ano}>
									{ano}
								</option>
							))}
						</select>
						<label htmlFor="floatingSelectAno">Selecione o Ano</label>
					</div>
				) : props.hrIni ? (
					<>
						<div className="d-flex col-12">
							<div className="form-floating mb-3 me-2 col-6">
								<input
									type="date"
									onChange={(e) => {
										parametrosData(e.target.value, "ini");
									}}
									className="form-control"
									id="date"
									value={props.dtini}
								/>
								<label htmlFor="floatingInput">Data Inicial</label>
							</div>
							<div className="form-floating mb-3 col-6">
								<input
									type="time"
									onChange={(e) => {
										props.setHrIni(e.target.value);
									}}
									className="form-control"
									id="date"
									value={props.hrIni}
								/>
								<label htmlFor="floatingInput">Hora Inicial</label>
							</div>
						</div>
						<div className="d-flex col-12">
							<div className="form-floating mb-3 me-2 col-6">
								<input
									type="date"
									onChange={(e) => {
										parametrosData(e.target.value, "fim");
									}}
									className="form-control"
									id="floatingInput"
									value={props.dtfim}
								/>
								<label htmlFor="floatingInput">Data Final</label>
							</div>
							<div className="form-floating mb-3 col-6">
								<input
									type="time"
									onChange={(e) => {
										props.setHrFim(e.target.value);
									}}
									className="form-control"
									id="date"
									value={props.hrFim}
								/>
								<label htmlFor="floatingInput">Hora Final</label>
							</div>
						</div>

						<ListFilterCaixaColaborador //
							isSelectCaixa={props.isSelectCaixa}
							setIsSelectCaixa={props.setIsSelectCaixa}
							setIdCaixaOuColaborador={props.setIdCaixaOuColaborador}
							idCaixaOuColaborador={props.idCaixaOuColaborador}
							setNomeOuColaborador={setNome}
							hideToggle={props.hideToggle}
						/>
					</>
				) : (
					<>
						<div className="form-floating mb-3">
							<input
								type="date"
								onChange={(e) => {
									parametrosData(e.target.value, "ini");
								}}
								className="form-control"
								id="date"
								value={props.dtini}
							/>
							<label htmlFor="floatingInput">Data Inicial</label>
						</div>
						<div className="form-floating mb-3">
							<input
								type="date"
								onChange={(e) => {
									parametrosData(e.target.value, "fim");
								}}
								className="form-control"
								id="floatingInput"
								value={props.dtfim}
							/>
							<label htmlFor="floatingInput">Data Final</label>
						</div>
					</>
				)}

				{props.filterLate ? (
					<div className="form-check form-switch">
						<input
							className="form-check-input"
							type="checkbox"
							role="switch"
							id="flexSwitchCheckDefault"
							checked={props.atrasados}
							onChange={(e) => props.setAtrasados(!props.atrasados)}
						/>
						<label className="form-check-label" htmlFor="flexSwitchCheckDefault">
							Somente pendentes
						</label>
					</div>
				) : null}
				<div className="row mb-1">
					<div className="col-12 mt-3 d-flex justify-content-end align-items-center">
						<button onClick={handleList} type="button mt-3" className="btn btn-lg btn-primary">
							Listar
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
}

export default FilterModal;
